import React from 'react';
import { Box} from '@mui/material';
import { Container } from '@mui/material';

import UpdateBuilderEEForm from '../Components/UpdateBuilderEEForm';

export default function UpdateBuilderEmployeePage() {
  return (
    <Box>
      <Container>
        <UpdateBuilderEEForm/>
      </Container>
    </Box>
  )
}
